<template>
	<!-- preview of item extra photos -->
	<div v-if="theItemPhotosAlbum" class="container-fluid">
		
		<!-- control the device display globally -->
        <div class="row">
            <div class="offset-lg-4 col-lg-4 offset-md-3 col-md-6 offset-sm-3 col-sm-6 col-12">
		
				<!-- display photo here -->
				<div class="row mt-3 mt-md-5">
					<div class="col-12">
						<div class="photo-mode">
							<img :src="image" class="photo-mode-img" alt="aNewItem Item Photos">
						</div>
					</div>
					<div class="col-12 mt-3" style="z-index: 50000;">
						<div class="float-left">
							<i @click="clickedImage--" class="fas fa-chevron-circle-left fa-2x text-dark-green clickable"></i>
						</div>
						<div class="float-right">
							<i @click="clickedImage++" class="fas fa-chevron-circle-right fa-2x text-dark-green clickable"></i>
						</div>
						<div class="clearfix"></div>
					</div>
				</div>

				<!-- photos back links -->
				<div class="photo-mode-links-box pb-md-3" style="z-index: 40000;">
					<div class="row mt-2">
						<div class="col-12 text-center">
							<small class="font-weight-bold">
								( {{clickedImage + 1}} / {{images.length}} )
							</small>
							<div class="scroll-box-horizontally text-center mx-3">
								<i 
									@click="clickedImage = index" 
									v-for="(image, index) in images" 
									:key="index" 
									class="fas fa-dot-circle fa-xs mx-1 clickable" 
									v-bind:class="{ 'text-dark-green' : index === clickedImage }" 
								></i>
							</div>
						</div>
					</div>
					<div class="row mt-2">
						<div class="col-12">
							<div class="text-center">
								<router-link :to="{ name: 'item-details', params: { itemTitle: itemTitle, itemId: itemId } }" 
									:title="`${itemTitle} - aNewItem.com`" class="btn btn-outline-danger btn-sm">
									<small class="font-weight-bold"><i class="fas fa-times"></i> Close Preview</small>
								</router-link>
							</div>
						</div>
					</div>
					<div class="row mt-2">
						<div class="col-12">
							<div class="text-center">
								<router-link :to="{ name: 'home' }" :title="`Home - aNewItem.com`">
									<small>&copy; aNewItem</small>
								</router-link>
							</div>
						</div>
					</div>
				</div>
				
			</div>
		</div>
	</div>
</template>
 
<script>
import { mapActions, mapGetters } from 'vuex'
import { appendImgHostUrl } from '@/store/dry'
import LayoutAuth from '@/layouts/Auth.vue'

export default {
	name: "ItemPhotosAlbum",
	props: {
		itemId: {
			type: String,
			require: true
		},
		itemTitle: {
			type: String,
			require: true
		},
		photoIndex: {
			type: String,
			require: true
		},
	},
	data() {
		return {
			photoHolder: require('../../../../../public/img/web/anewitem-noimage.jpg'),
			image: null,
			images: [],
			clickedImage: 0
		}
	},
	methods: {
		...mapActions(['itemPhotosAction']),
		showPhoto(imageIndex) {
			// ensure the images array exists
			if(!this.images && !this.images.length) return

			// ensure the clicked image index is not of a negative integer value
			if(imageIndex < 1) { imageIndex = 0 }

			// ensure the clicked image index is not higer than total images
			if(imageIndex >= this.images.length) { imageIndex = this.images.length - 1 }

			this.image = this.images[imageIndex]
			this.clickedImage = imageIndex
		},
		extractedItemPhotos(itemPhotos) {
            if(itemPhotos){
				let src = ""
                for(let x=0; x < itemPhotos.length; x++){
					if(itemPhotos[x].path){
						// fetch the path to the hd quality version of the item photos via photoObj.path
						src = appendImgHostUrl(itemPhotos[x].path)
					}else{
						src = this.photoHolder
					}
					this.images.push(src)
                }
            }else{
				this.images.push(this.photoHolder)
			}
        },
		itemPhotosFxn(theItemId) {
            let itemObj = {
                itemId: theItemId
            }
            this.itemPhotosAction(itemObj)
			.then((data) => {
				// auto append the resource url on to the photo paths 
				this.extractedItemPhotos(data.result.photos)
			})
			.catch((e) => {})
        },
	},
	computed: {
		...mapGetters(['itemPhotosAlbum']),
		theItemPhotosAlbum() {
			if(this.itemPhotosAlbum) {
				/**
				 * first convert the photoIndex value back to integer, 
				 * then check if the user clicked a specific photo, show it instead of main photo
				 * */ 
				let firstPhotoIndex = this.photoIndex ? parseInt(this.photoIndex) : 0 
				this.showPhoto(firstPhotoIndex)
				return this.itemPhotosAlbum
			}
			return false
		}
	},
	watch: {
        itemId() {
            this.itemPhotosFxn(this.itemId)
        },
		clickedImage() {
			this.showPhoto(this.clickedImage)
		}
    },
	created() {
		this.itemPhotosFxn(this.itemId)
		this.$emit('update:layout', LayoutAuth);
	}
}
</script> 